import { createI18n } from 'vue-i18n';
import de from './de.json';
import en from './en.json';

// Sprache aus dem Browser erkennen oder gespeicherte Sprache verwenden
function detectLanguage() {
  // Vorrangig: gespeicherte Sprache aus localStorage
  const storedLang = localStorage.getItem('language');
  if (storedLang && ['de', 'en'].includes(storedLang)) {
    return storedLang;
  }
  
  // Alternativ: Browser-Sprache erkennen
  const browserLang = navigator.language.split('-')[0];
  if (['de', 'en'].includes(browserLang)) {
    return browserLang;
  }
  
  // Fallback: Deutsch als Standardsprache
  return 'de';
}

export const i18n = createI18n({
  legacy: false, // Vue 3 Composition API verwenden
  locale: detectLanguage(),
  fallbackLocale: 'de',
  messages: {
    de,
    en
  }
});

// Funktion zum Ändern der Sprache
export function setLanguage(lang) {
  if (['de', 'en'].includes(lang)) {
    i18n.global.locale.value = lang;
    localStorage.setItem('language', lang);
    document.documentElement.setAttribute('lang', lang);
  }
}

// Initialen lang-Attribut setzen
document.documentElement.setAttribute('lang', detectLanguage()); 